export const Educationdata=[
    {
        company:"InspironLabs Software Systems",
        designation:"Software Engineer",
        date:"April 2022 - Present",
        logo:"https://freelistingindia.s3.ap-south-1.amazonaws.com/listings/MicrosoftTeamsimage63645df19216e3b_thumb.png"
    },
    {
    company:"Masai School",
    designation:"Full Satck Web Development Course",
    date:"Sep 2021 - April 2022",
    logo:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8i0LxsxqCwppM2bmmRMXTVvcdxuyDvC9fgk1T7Ieyyg&s"
},
// {
//     company:"U.I.T - R.G.P.V",
//     designation:"Full Satck Web Development",
//     date:"2015 - 2019",
//     logo:"https://www.uitrgpv.ac.in/Images/img_logo.gif"

// }
]